import clsx from "clsx";
import React from "react";
import Lottie from "lottie-react";
import errorUnKnown from "./unKnown.json";
import { Typography } from "../../../baseElement";

interface PropsType {
  message?: string;
  textClass?: string;
}
export default function UnKnownError(props: PropsType) {
  const { message, textClass } = props;
  return (
    <div className="mt-5">
      <Typography className={clsx("text-center", textClass)}>
        {message}
      </Typography>
      <Lottie animationData={errorUnKnown} loop={true} />
    </div>
  );
}
